import { useQuery } from "@tanstack/react-query";
import { fetchAccountTypes } from "../../../services/accountTypes";

export function useAccountTypes(
  auth: "vendor" | "bouncer" = "vendor",
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: ["gvm-account-types", auth],
    queryFn: () => fetchAccountTypes({ auth }),
    staleTime: 10 * 60_000,
    refetchOnWindowFocus: false,
    enabled: options.enabled ?? true,
  });
}
